module.exports = __webpack_public_path__ + "fonts/gb.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/gb.svg
// module id = 848
// module chunks = 2